import React from 'react';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import { breedAttributePagesResourceDefinition } from './utils/queryDefinitions';
import BreederProfileLocationLinksGroup from './BreederProfileLocationLinksGroup';

interface BreederProfileBreedAttributePagesProps {
  breedId: number | string;
  breedName: string;
  limit?: number;
}

export default function BreederProfileBreedAttributePages({
  breedId,
  breedName,
  limit = 10
}: BreederProfileBreedAttributePagesProps) {
  const { value: attributePagesData, isFetching } = useResourceQuery(
    breedAttributePagesResourceDefinition(breedId, limit)
  );

  return (
    <BreederProfileLocationLinksGroup
      linksData={attributePagesData}
      header={`Refine your ${breedName} search`}
      wideLayout
      linkType="breed_attribute"
      isFetching={isFetching}
    />
  );
}
